<script>
    /*
    	ReferralQuestionSet.svelte

        Parent is a ReferralSection (which contains questions)

        10/19 TODO: move required checks into each section?
        10/19 TODO: improve the shouldShowQuestion to handle hidden required fields
    */

    import { onMount } from 'svelte';
    import { MULTI_CHOICE } from './question-types.js';


    // TCARE components
    import ReferralQuestion from './ReferralQuestion.svelte';

    // SMUI components

    export let section;
    export let setValue;

    onMount(() => {
    })

    // interates an array - not object props
    const lookupQuestion = (id) => {
        for (const question of section.questions) {
            if (question.id === id) {
                return question;
            }
        }
        return null;
    }

    // question's value must match dependency answer
    // should this be recursive? (parents)
    const shouldShowQuestion = (question) => {
        // console.log('ReferralQuestionSet shouldShowQuestion: ', question);

        if (typeof question.depId === "undefined") return true;         // prop not present
        if (question.depId === null) return true;                       // prop set to null

        let depQuestion = lookupQuestion(question.depId);
        if (depQuestion === null) return false;

        // console.log(question.id + ' depQuestion: ', depQuestion);

        // values can be false so do not just check falsey - check for !== null
        if (depQuestion.questionType === MULTI_CHOICE) {
            // value must be in the value array for checkbox types
            return depQuestion.value !== null ? depQuestion.value.includes(question.depValue) : false;
        } else {
            // just match the value for all other types
            return depQuestion.value !== null ? depQuestion.value === question.depValue : false;
        }
    }

</script>

<style>
    .referral-questions {
        width: 90%;
        margin-left: 10%;
        margin-bottom: 20px;
        /* border: 1px solid black; */
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>


<div class="referral-questions">
    {#each section.questions as question}
        {#if shouldShowQuestion(question)}
            <ReferralQuestion {question} {setValue} />
        {/if}
    {/each}
</div>
